<template>
    <div class="legend">
        <div
            class="item"
            v-for="item in items"
            :class="[item.key]"
            :key="item.key"
        >
            {{ item.name }}
        </div>
    </div>
</template>

<script>
import {getEducationProgramTypeName} from '@/tools/education';

export default {
    name: 'TimelineLegendDesktop',
    data: () => ({
        items: [
            {
                entityType: 'course',
                educationType: 'additional',
            },
            {
                entityType: 'webinar',
                educationType: 'additional',
            },
            {
                entityType: 'program',
                educationType: 'higher',
            },
            {
                entityType: 'program',
                educationType: 'additional',
            },
            {
                entityType: 'program',
                educationType: 'secondary',
            },
        ].map(v => ({
            key:`${v.entityType}_${v.educationType}`,
            name: getEducationProgramTypeName(v),
        })),
    }),
};
</script>

<style lang="scss" scoped>
    @import '@/styles/rem';
    @import '@/styles/track';

    .legend {
        display: flex;
        flex-wrap: wrap;

        .item {
            display: flex;
            align-items: center;
            margin-right: 16px;
            font-size: 14px;
            line-height: 20px;
            color: #98A0A9;
            margin-bottom: 4px;

            @each $type, $color in $educationalProgramTypes {
                &.#{$type}::before {
                    margin-right: 6px;
                    background-color: $color;
                    content: " ";
                    display: block;
                    border-radius: 50%;
                    width: 8px;
                    height: 8px;
                }
            }
        }
    }
</style>
